class ObjectRegistry {
    private factories = {};
    private objects = {}

    public register(key: string, factory: () => any) {
        this.factories[key] = factory;
    }

    public resolve(key: string) {
        if (!this.objects[key]) {
            this.objects[key] = this.factories[key]();
        }
        return this.objects[key];
    }
}

export default new ObjectRegistry();
